import React from 'react';
import { connect } from 'react-redux';
import { closeModalMessage } from 'common/actions/appActions';
import ModalMessaging from './ModalMessaging';

class MessagingContainer extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.dispatch(closeModalMessage());
    }

    render() {
        return (
            <ModalMessaging
                showModalMessage={this.props.showModalMessage}
                closeModal={this.closeModal}
                messageType={this.props.messageType}
                messageData={this.props.messageData}
            />
        );
    }
}

MessagingContainer.propTypes = {
    dispatch: React.PropTypes.func,
    showModalMessage: React.PropTypes.bool,
    messageType: React.PropTypes.string,
    messageData: React.PropTypes.object
};

const mapStateToProps = (state) => {
    const { app: { showModalMessage = false, messageType = '', messageData = null } } = state;

    return {
        showModalMessage,
        messageType,
        messageData
    };
};

export default connect(mapStateToProps)(MessagingContainer);



// WEBPACK FOOTER //
// ./app/modal/messaging/MessagingContainer.js